import { CvaListProps } from '../types';
import { CatList } from '@blocks-react/components/List';

export const CVAList = ({ children }: CvaListProps) => {
  return <CatList>{children}</CatList>;
};
